import { render } from "./bargaining_settings.vue?vue&type=template&id=ee3d6ad0&ts=true"
import script from "./bargaining_settings.vue?vue&type=script&lang=ts"
export * from "./bargaining_settings.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__